import { Component, Injector } from '@angular/core';
import { FilterOptions, FilterBuilder, FilterComponent } from '@mango/core';
import { User } from '../user';

@Component({
    selector: 'mtp-user-multiple-activations-filter',
    templateUrl: './user-multiple-activations-filter.component.html'
})
export class UserMultipleActivationFilterComponent extends FilterComponent<User>  {

    constructor(injector: Injector) {
        super(injector, User, new FilterOptions<User>().like("name"));
    }

    ngOnInit() {
        super.ngOnInit();
    }
} 